var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0%",
    y: "0%",
    width: "100%",
    height: "100%",
    viewBox: "0 0 24.0 24.0",
    enableBackground: "new 0 0 24.0 24.0",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "fillGrad55",
    cx: "54.597%",
    cy: "24.699%",
    fx: "54.597%",
    fy: "24.699%",
    r: "69.048%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0.000%",
    style: {
      stopColor: "rgb(167,230,255)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "47.586%",
    style: {
      stopColor: "rgb(83,206,255)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100.000%",
    style: {
      stopColor: "rgb(167,230,255)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "stkGrad55",
    cx: "-27.463%",
    cy: "116.772%",
    fx: "-27.463%",
    fy: "116.772%",
    r: "171.827%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0.000%",
    style: {
      stopColor: "rgb(255,255,255)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "53.219%",
    style: {
      stopColor: "rgb(83,206,255)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100.000%",
    style: {
      stopColor: "rgb(255,255,255)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "fillGrad56",
    cx: "41.353%",
    cy: "65.420%",
    fx: "41.353%",
    fy: "65.420%",
    r: "78.664%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0.000%",
    style: {
      stopColor: "rgb(231,69,24)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100.000%",
    style: {
      stopColor: "rgb(245,154,37)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "stkGrad56",
    x1: "-4.195%",
    y1: "166.197%",
    x2: "95.261%",
    y2: "-27.658%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0.000%",
    style: {
      stopColor: "rgb(231,69,24)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100.000%",
    style: {
      stopColor: "rgb(245,154,37)",
      stopOpacity: 1
    }
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#005D64",
    stroke: "#005D64",
    fillOpacity: 1,
    strokeOpacity: 1,
    fillRule: "nonzero",
    strokeWidth: 0.048,
    strokeLinejoin: "round",
    strokeLinecap: "square",
    d: "M2.19,9.45L12.29,9.46C14.62,9.70,13.96,13.10,11.05,13.03L11.55,13.71L17.85,13.71C18.31,13.61,18.31,13.14,17.93,12.99L15.08,12.95C13.50,12.17,13.46,10.34,16.17,9.50L20.94,9.50L20.61,10.98L16.17,10.99C15.78,11.05,15.76,11.42,16.08,11.58L18.67,11.59C20.61,12.66,20.35,14.16,18.28,15.25L10.51,15.25L8.70,13.27L8.03,15.25L6.41,15.25L6.98,12.92C7.13,12.34,7.84,11.65,8.58,11.62L11.43,11.61C11.72,11.57,11.95,11.19,11.72,11.01L5.87,11.02L4.70,15.25L3.00,15.25L4.07,10.98L1.69,10.98L2.19,9.45z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    transform: "rotate(-0.00 16.75 9.70)",
    fill: "url(#fillGrad55)",
    stroke: "url(#stkGrad55)",
    fillOpacity: 1,
    strokeOpacity: 1,
    fillRule: "nonzero",
    strokeWidth: 0.024,
    strokeLinejoin: "round",
    strokeLinecap: "square",
    d: "M14.45,7.56C26.46,1.32,20.70,11.03,10.22,14.95L10.50,15.27C23.72,10.89,29.26,-1.94,14.45,7.56z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    transform: "rotate(-0.00 13.42 8.41)",
    fill: "url(#fillGrad56)",
    stroke: "url(#stkGrad56)",
    fillOpacity: 1,
    strokeOpacity: 1,
    fillRule: "nonzero",
    strokeWidth: 0.024,
    strokeLinejoin: "round",
    strokeLinecap: "square",
    d: "M13.42,7.57C13.89,7.57,14.28,7.95,14.28,8.41C14.28,8.87,13.89,9.25,13.42,9.25C12.94,9.25,12.56,8.87,12.56,8.41C12.56,7.95,12.94,7.57,13.42,7.57z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.dcec7a6680b51bf67e74bf77895bce0d.svg";
export { ForwardRef as ReactComponent };